var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-page"},[_c('app-view-layout',{attrs:{"header":"Ustawienia konta","fluid":""},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('SettingsUserData')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }